import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPieChart = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={200} height={200} fill='none' {...props}>
    <path
      fill='#E0E3EB'
      d='M0 99.916C0 44.734 44.77 0 99.998 0c27.254 0 51.962 10.894 69.999 28.561L99.998 99.916v99.914C44.771 199.83 0 155.097 0 99.916'
    />
    <path
      fill='#E0E3EB'
      d='M100.002 199.83C44.774 199.83.003 155.097.003 99.915c0-27.23 10.904-51.918 28.586-69.94l71.413 69.94H200c0 55.182-44.771 99.915-99.998 99.915'
    />
    <path
      fill='#E0E3EB'
      d='M199.995 99.793c0 55.181-44.771 99.914-99.998 99.914-27.254 0-51.962-10.893-69.999-28.561l69.999-71.353z'
    />
    <path fill='#E0E3EB' d='M199.956 100.086c0 55.181-44.771 99.914-99.998 99.914v-99.914z' />
    <path
      fill='#E0E3EB'
      d='M99.997 0c55.227 0 99.998 44.733 99.998 99.915 0 39.34-22.755 73.37-55.832 89.666L99.997 99.915z'
    />
    <circle cx={100} cy={100} r={68.75} fill='currentColor' />
  </svg>
);
export default SvgPieChart;
